const messages = {
  filter: {
    apply: 'Aplicar',
    cleanFilters: 'Limpar filtros',
    filter: 'Filtros',
    clean: 'Limpar',
    price: 'Preço',
    to: 'até',
    currency: 'R$',
    sort: {
      title: 'Ordenar',
      newest: 'Mais recentes',
      oldest: 'Mais antigos',
      lowest: 'Menor preço',
      highest: 'Maior preço',
      az: 'Alfabética',
      za: 'Alfabética inversa'
    },
    displayModeError: 'O modo de exibição escolhido não é válido!',
    search: {
      placeholder: 'Digite sua busca',
      cta: 'Aperte enter'
    }
  }
}

export type Translation = typeof messages

export { messages }
